<h3>
    Dienstleistungsarten
    <mat-icon
      svgIcon="innogy_picto_speech-bubble_exclamationmark"
      aria-hidden="false"
      aria-label="{{ tooltipText }}"
      [matTooltip]="tooltipText"
      matTooltipPosition="above"
      matTooltipClass="multiline-tooltip"
    >
    </mat-icon>
</h3>
<mat-card>
    <mat-card-content>
        <table mat-table [dataSource]="dienstleistungsarten()" data-qa="dienstleistungsarten-table">
            <ng-container matColumnDef="diebstleistungsartName">
                <th mat-header-cell *matHeaderCellDef>Dienstleistungsart</th>
                <td mat-cell *matCellDef="let element"> {{element.dienstleistungsartName}} </td>
            </ng-container>
            <ng-container matColumnDef="countStadtwerke">
                <th mat-header-cell *matHeaderCellDef>Anzahl STW</th>
                <td mat-cell *matCellDef="let element"> {{element.countStadtwerke}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card-content>
</mat-card>
